import React from "react";

/**
 * Scatters SVG coffee beans across a container with slow drift animation.
 * Purely decorative — pointer-events: none.
 */
const CoffeeBean = ({ size = 24, color = "#4A2410", stroke = "#8B4513", angle = 0, opacity = 0.5 }) => (
  <svg width={size} height={size * 1.3} viewBox="0 0 40 52" style={{ transform: `rotate(${angle}deg)`, opacity }}>
    <ellipse cx="20" cy="26" rx="14" ry="24" fill={color} stroke={stroke} strokeWidth="1.5" />
    <path d="M20 4 C 12 14, 12 38, 20 48" fill="none" stroke={stroke} strokeWidth="1.4" strokeLinecap="round" />
    <path d="M18 8 C 14 16, 14 36, 18 44" fill="none" stroke="rgba(0,0,0,0.35)" strokeWidth="0.6" />
  </svg>
);

const positions = [
  { top: "8%",  left: "4%",  size: 32, angle: 15,   delay: "0s",   opacity: 0.35 },
  { top: "18%", left: "88%", size: 22, angle: -25,  delay: "1.2s", opacity: 0.3  },
  { top: "42%", left: "2%",  size: 28, angle: 55,   delay: "2.4s", opacity: 0.28 },
  { top: "70%", left: "92%", size: 36, angle: -40,  delay: "0.8s", opacity: 0.32 },
  { top: "88%", left: "10%", size: 24, angle: 120,  delay: "3.5s", opacity: 0.25 },
  { top: "60%", left: "50%", size: 20, angle: -70,  delay: "1.8s", opacity: 0.18 },
  { top: "30%", left: "45%", size: 18, angle: 200,  delay: "2.9s", opacity: 0.15 },
  { top: "80%", left: "70%", size: 30, angle: 90,   delay: "4.2s", opacity: 0.3  },
];

/**
 * Full-page floating bean layer (drops as absolute inside a relative parent).
 */
export default function CoffeeBeans({ density = "normal", zIndex = 1 }) {
  const list = density === "sparse" ? positions.slice(0, 4) : positions;
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden" style={{ zIndex }} aria-hidden>
      {list.map((p) => (
        <div
          key={`bean-${p.top}-${p.left}-${p.size}`}
          className="absolute bean-icon"
          style={{
            top: p.top,
            left: p.left,
            animationDelay: p.delay,
            animationDuration: `${8 + (list.indexOf(p) % 4) * 2}s`,
          }}
        >
          <CoffeeBean size={p.size} angle={p.angle} opacity={p.opacity} />
        </div>
      ))}
    </div>
  );
}
